// src/services/bookingService.js
import api from './api';

export const bookingService = {
  // Calculate booking amount
  calculateBookingAmount: async (carId) => {
    try {
      const res = await api.post('/bookings/calculate_booking_amount', { car_id: carId });
      return res.data;
    } catch (error) {
      console.error('Calculate booking amount error:', error);
      throw error.response?.data || error;
    }
  },

  // Check car availability
  checkAvailability: async (carId) => {
    try {
      const res = await api.post('/bookings/check_availability', { car_id: carId });
      return res.data;
    } catch (error) {
      console.error('Check availability error:', error);
      throw error.response?.data || error;
    }
  },

  // Create a new booking
  createBooking: async (carId, scheduledAt = null) => {
    try {
      const bookingData = {
        car_id: carId,
        scheduled_at: scheduledAt || new Date(Date.now() + 48 * 60 * 60 * 1000).toISOString()
      };
      
      const res = await api.post('/bookings', bookingData);
      return res.data;
    } catch (error) {
      console.error('Booking creation error:', error);
      throw error.response?.data || error;
    }
  },

  // Get all user bookings
  getAllBookings: async () => {
    try {
      const res = await api.get('/bookings');
      return res.data;
    } catch (error) {
      console.error('Get bookings error:', error);
      throw error.response?.data || error;
    }
  },

  // Get single booking
  getBooking: async (bookingId) => {
    try {
      const res = await api.get(`/bookings/${bookingId}`);
      return res.data;
    } catch (error) {
      console.error('Get booking error:', error);
      throw error.response?.data || error;
    }
  },

  // Cancel booking
  cancelBooking: async (bookingId, reason = null) => {
    try {
      const res = await api.post(`/bookings/${bookingId}/cancel`, { reason });
      return res.data;
    } catch (error) {
      console.error('Cancel booking error:', error);
      throw error.response?.data || error;
    }
  }
};